import React from "react";
import LoanApplication from "../../../models/loan/loanApplication";
import Table from "react-bootstrap/esm/Table";
import "./EntityApplicantSection.css";
import loanApplicationUtility from "utilities/LoanApplicationUtility";

interface EntityApplicantSectionProps {
  loanDetails: LoanApplication
}

export default class EntityApplicantSection extends React.Component<EntityApplicantSectionProps> {
  render() {
    return (
      <>
        {this.props.loanDetails.entityApplicant != undefined &&
          <div>
            <h3>Entity Applicant</h3>
            <Table bordered striped={false} size="sm">
              <tbody>
                <tr>
                  <td width="250px" className="app-info"><strong>Entity Name</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.organizationName}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Date Organized</strong></td>
                  <td className="app-info">{loanApplicationUtility.GetFullYearDateText(this.props.loanDetails.entityApplicant.dateOrganized ?? new Date())}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>EIN</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.ein}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Address</strong></td>
                  <td className="app-info">{`${this.props.loanDetails.entityApplicant.address}, ${this.props.loanDetails.entityApplicant.city}, ${this.props.loanDetails.entityApplicant.state} ${this.props.loanDetails.entityApplicant.zipCode}`}</td>
                </tr>
                {this.props.loanDetails.entityApplicant.extraDataObject?.principalOwnershipInformation?.map((po,i) => {
                  return (
                    <tr>
                      <td width="250px" className="app-info"><strong>{`Principal/Owner #${i+1}`}</strong></td>
                      <td className="app-info">{`${po.principalOwnerFirstName} ${po.principalOwnerLastName}, ${po.ssnTaxId}, ${po.physicalAddress ?? po.fullAddress}, ${po.city ?? 'N/A'}, ${po.state ?? 'N/A'} ${po.zipCode ?? 'N/A'}, ${loanApplicationUtility.FormatPhoneNumber(po.phoneNumber ?? '')}, ${po.percentageOwned}%, ${po.title}`}</td>
                    </tr>
                  )
                })}
                <tr>
                  <td width="250px" className="app-info"><strong>Was this business formed in the United States?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessFormedInUsa ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Is your business directly or indirectly involved in marijuana, cannabis, hemp or CBD?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessInvolvedWithCannabis ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Does your business issue, exchange or redeem virtual currency (i.e. Bit Coin)?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessExchangeDigitalCurrency ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Is your business a casino?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessCasino ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Is your business involved in internet gambling or have any games or financial activities on your website?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessInInternetGambling ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                  <td width="250px" className="app-info"><strong>Is your business publicly traded?</strong></td>
                  <td className="app-info">{this.props.loanDetails.entityApplicant.extraDataObject?.isBusinessPubliclyTraded ? 'Yes' : 'No'}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        }
      </>
    );
  }
}